import React, { type JSX } from 'react';
import { useQuery } from '@apollo/client';
import StandardAnalysQueryDoc from './StandardAnalysQuery.gql';
import {
  StandardAnalysQuery as IData,
  StandardAnalysQueryVariables as IVariables,
} from './_QueryTypes/StandardAnalysQuery';
import { IEgenLokalAnalys } from './AnalysEgnaLokalaQuery';

interface IProps {
  dbname: string;
  children: (analysNamn: IEgenLokalAnalys[], loading: boolean) => JSX.Element;
}

const StandardAnalysQuery: React.FunctionComponent<IProps> = props => {
  const queryResult = useQuery<IData, IVariables>(StandardAnalysQueryDoc, {
    variables: {
      dbname: props.dbname,
    },
    fetchPolicy: 'cache-and-network',
  });

  if (
    queryResult.loading ||
    !queryResult.data ||
    !queryResult.data.db ||
    !queryResult.data.db.EKEkonomirapport_All
  ) {
    return props.children([], queryResult.loading);
  }

  return props.children(
    queryResult.data.db.EKEkonomirapport_All.map(standardAnalys => ({
      namn: standardAnalys.BENAMNING,
      id: standardAnalys.id,
    })),
    queryResult.loading
  );
};

export default StandardAnalysQuery;
